module.exports = [
	{
		"component": "albedo",
		"rules": [
			{
				"key": "workflow",
				"value": "metalness"
			},
			{
				"key": "workflow",
				"value": "specular",
				"whenMissing": "diffuse"
			}
		]
	},
	{
		"component": "bump",
		"rules": [
			{
				"key": "context",
				"value": "offline"
			}
		]
	},
	{
		"component": "normalbump",
		"rules": [
			{
				"key": "context",
				"value": "offline"
			}
		]
	},
	{
		"component": "diffuse",
		"rules": [
			{
				"key": "workflow",
				"value": "specular"
			}
		]
	},
	{
		"component": "cavity",
		"rules": [
			{
				"key": "workflow",
				"value": "metalness"
			}
		]
	},
	{
		"component": "gloss",
		"rules": [
			{
				"key": "microsurface",
				"value": "gloss"
			}
		]
	},
	{
		"component": "roughness",
		"rules": [
			{
				"key": "microsurface",
				"value": "roughness"
			}
		]
	},
	{
		"component": "specular",
		"rules": [
			{
				"key": "workflow",
				"value": "specular"
			}
		]
	},
	{
		"component": "metalness",
		"rules": [
			{
				"key": "workflow",
				"value": "metalness"
			}
		]
	}
]


//////////////////
// WEBPACK FOOTER
// ./src/data/asset/settings/rules.json
// module id = 1184
// module chunks = 0